import { CompanySettingsApiClient, CompanyContext } from '@/clients/companySettingsApiClient';

/**
 * Service for handling company settings and context
 */
export class CompanySettingsService {
  /**
   * Get company context for the current user's active company
   * @returns Company context
   */
  async getContext(): Promise<CompanyContext> {
    return CompanySettingsApiClient.getContext();
  }

  /**
   * Update company context for the current user's active company
   * @param contextText The context text to update
   * @returns Updated company context
   */
  async updateContext(
    contextText: string,
    companyType?: string | null,
    options: { confirmLegalFormChange?: boolean } = {},
  ): Promise<CompanyContext> {
    return CompanySettingsApiClient.updateContext(contextText, companyType, options);
  }
}
